// extracted by css-extract-rspack-plugin
export default {"paginationControls":"BCYxV"};